cafm.browsers.ieMobile = {

    fixKendoDate: function(args){

        var widget = args.widget;
        var element = widget.element;

        element.attr('readonly', 'true');
        
        widget.bind('change', function (args) {

            element.removeData('preventClose');
            widget.close();
            element.focus();
        });
    },
    fixKendoDateTime: function (args) {

        args.widget.element.attr('readonly', 'true');
        ieMobile.fixKendoListContainer(args);
    },
    fixKendoDropdown: function (args) {
        
        ieMobile.fixKendoListContainer(args);
    },
    fixKendoComboBox: function(args) {

        ieMobile.fixKendoListContainer(args);
    },
    fixKendoListContainer: function (args) {

        var widget = args.widget;
        var element = widget.element;
        var relevance = isFunc(args.relevance) ? args.relevance : null;

        widget.bind('open', function (args) {

            if (!relevance || relevance(args)) {

                element.data('preventClose', true);

                $('body').on('MSPointerDown.cafm touchstart.cafm', function (ev) {

                    if (!$(ev.target).parents('.k-animation-container:first').length) {

                        element.removeData('preventClose');
                        widget.close();
                    }
                });
            }
        });

        widget.bind('change', function (args) {
            
            element.removeData('preventClose');
            widget.close();
            element.focus();
        });

        widget.bind('close', function (args) {
                        
            if (!relevance || relevance(args)) {

                if (element.data('preventClose')) {

                    args.preventDefault();
                }
                else {

                    $('body').off('MSPointerDown.cafm');
                    element.removeData('preventClose');
                }
            }
        });
    }
}
var ieMobile = cafm.browsers.ieMobile;